var _rect, _path, _line, _line2, _line3, _line4, _ellipse, _path2, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.392,
    y: 2.988,
    width: 5.217,
    height: 4.505
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.925,14.18c.218-.742.34-1.578.34-2.463,0-1.693-.448-3.208-1.153-4.224h-4.224c-.705,1.016-1.153,2.531-1.153,4.224,0,.885.123,1.721.34,2.463l-3.232,1.818c-1.293.727-2.093,2.095-2.093,3.578v18.189c0,.689.558,1.247,1.247,1.247h14.006c.689,0,1.247-.558,1.247-1.247v-18.189c0-1.483-.8-2.851-2.093-3.578l-3.232-1.818Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.608,
    y1: 5.24,
    x2: 18.392,
    y2: 5.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.266,
    y1: 11.716,
    x2: 17.734,
    y2: 11.716
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.25,
    y1: 19.725,
    x2: 12.75,
    y2: 19.725
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29.25,
    y1: 35.187,
    x2: 12.75,
    y2: 35.187
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.001,
    cy: 27.766,
    rx: 3.151,
    ry: 1.335
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.449,24.715c-1.342-1.197-3.286-1.951-5.449-1.951s-4.107.753-5.449,1.951"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.835,
    y1: 32.208,
    x2: 26.205,
    y2: 32.208
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAlcohol);
export default __webpack_public_path__ + "static/media/indoor-alcohol.a84d379583ca8509cfa5296d606a5ae7.svg";
export { ForwardRef as ReactComponent };